'use client'
import './FeaturedResources.css';
// import { LayoutFeaturedResources as FeaturedResources } from "trimble-terra/LayoutFeaturedResources";
import { LayoutFeaturedResources as FeaturedResources } from "trimble-terra";
import { processLinkUrl  } from "@/utils/linkUtils"
import { normalToMachineTheme } from "@/lib/utils"
import { qualifyImageUrl } from "@/lib/formatImages"
const FormatFeaturedResources = ( data: any, draftEnabled: boolean ) => {

  const formatCtaLinks = (ctas: any) => {
    return ctas?.map((cta: any) => {
      return {
        text: cta?.textLabel,
        url: processLinkUrl(cta?.destination ? cta?.destination : cta?.url ? cta?.url : null),
        ariaLabel: cta?.ariaLabel,
        isPrimary: cta?.isPrimary || false
      }
    })
  }

  const formattedResourceItems = data?.data?.featuredResourcesCollection?.items?.map((resource: any) => {
    
    return {
      header: resource?.header,
      description: resource?.shortDescription,
      image: {
        src: qualifyImageUrl(resource?.image?.url, 88, 88) || null,
        alt: resource?.image.title,
        width: 88,
        height: 88,
      },
      link: {
        text: resource?.linkedResource?.textLabel || resource?.linkedResource?.destination?.title,
        url: processLinkUrl(
          resource?.linkedResource?.destination 
            ? resource?.linkedResource?.destination 
            : resource?.linkedResource?.url
              ? resource?.linkedResource?.url 
                : null 
        ),
        ariaLabel: resource?.linkedResource?.ariaLabel,
        isPrimary: resource?.linkedResource?.isPrimary || false
      }
    }
  });

  const formattedFeaturedResources = {
    eyebrow: data?.data?.eyebrow,
    header: data?.data?.header,
    subheader: data?.data?.subheader,
    description: data?.data?.description,
    featuredResourceItems: formattedResourceItems,
    ctas: formatCtaLinks(data?.data?.buttonsCollection?.items),
    isHeaderBig: data?.data?.isHeaderBig || false,
    presetTheme: normalToMachineTheme(data?.data?.theme)
  }

  return (
    <div className="featured-resources-section">
      <FeaturedResources {...formattedFeaturedResources} /> 
    </div>
  );
}
export default FormatFeaturedResources;
